module.exports = __webpack_public_path__ + "img/zwy_SC.40e0db8b.jpg";